import { Trans, useTranslate } from "@similarweb/i18n-provider";
import { Rocket } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import demoModeTrackingService from "app/pages/sales-intelligence/services/tracking/demo-mode/trackingService";
import { useDemoModeStore } from "app/pages/sales-intelligence/store/demo-mode/useDemoModeStore";
import { demoModeKeys } from "app/pages/sales-intelligence/utils/i18n/demo-mode";

import { useIndustryTaxonomyDemoSession } from "../../../hooks/useIndustryTaxonomyDemoSession";

import { StyledCenteredTryButton, StyledIndustryDemoCalloutWrapper } from "./styles";

/** In-card promo shown on the legacy industry filter, offering entry into the v2 taxonomy demo. */
export const IndustryDemoCallout = () => {
    const { translate } = useTranslate();

    const session = useIndustryTaxonomyDemoSession();

    const enterDemo = useDemoModeStore((state) => state.enterDemo);

    const handleTryDemo = () => {
        demoModeTrackingService.trackDemoEnterClick(session.id);
        enterDemo(session);
    };

    return (
        <StyledIndustryDemoCalloutWrapper data-automation="industry-demo-callout">
            <Flex
                gap="12px"
                alignItems="center"
            >
                <Rocket
                    size="lg"
                    color={colorsPalettes.blue[400]}
                />
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon[500]}
                    flex="1 0"
                >
                    <Trans
                        i18nKey={demoModeKeys.calloutTitle(session.copyNamespace)}
                        t={translate}
                    />
                </Text>
            </Flex>
            <StyledCenteredTryButton
                type="flat"
                onClick={handleTryDemo}
                data-automation="industry-demo-callout-try"
            >
                {translate(demoModeKeys.calloutCta(session.copyNamespace))}
            </StyledCenteredTryButton>
        </StyledIndustryDemoCalloutWrapper>
    );
};
